'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var withShape = {};

exports.__exports = withShape;
